module.exports = "<div class=\"tick-tock-time\">\n  {{ currentTime }}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/tick-tock/tick-tock.component.html
// module id = 17
// module chunks = 0 1